// Kayıt edinim kanalı (2026-10-02): kullanıcının nereden geldiği (ChatGPT, Google, reklam, doğrudan…).
// Anahtar: memeet_acq = { first, last }. Kendi alan adları (memeet.lodos.io, *.lodos.io) dış temas sayılmaz.
// İlk temas 180 gün sabit kalır, son temas her dış gelişte güncellenir. Kayıtta sunucuya `acquisition` olarak gider;
// sınıflandırmayı sunucu yapar (users.acquisition_channel). Hiçbir hata kaydı engellemez.
// Tarayıcı dışı ortamlarda (SSR/masaüstü ön yükleme/test) window/localStorage yoksa sessizce hiçbir şey yapmaz.
const KEY = 'memeet_acq'
const OWN = /(^|\.)(memeet\.lodos\.io|lodos\.io)$/i
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id']
const FIRST_TTL = 180 * 86400000

function hasBrowser() {
  try {
    return typeof localStorage !== 'undefined' && localStorage !== null && typeof location !== 'undefined' && typeof document !== 'undefined'
  } catch (e) { return false }
}

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {} } catch (e) { return {} }
}

/** Uygulama açılışında çağrılır: dış yönlendirme ya da kampanya parametresi varsa temas kaydeder. */
export function captureTouch() {
  try {
    if (!hasBrowser()) return
    const q = new URLSearchParams(location.search)
    const touch = {}
    PARAMS.forEach((k) => { const v = q.get(k); if (v) touch[k] = v.slice(0, 200) })
    let refHost = ''
    try { refHost = document.referrer ? new URL(document.referrer).hostname : '' } catch (e) { refHost = '' }
    const external = refHost && !OWN.test(refHost) && refHost !== location.hostname
    if (external) touch.ref = document.referrer.split('?')[0].slice(0, 300)
    if (!Object.keys(touch).length) {
      // Hiç temas yoksa ilk ziyareti "doğrudan" olarak işaretle (yalnız bir kez)
      const cur = read()
      if (!cur.first) localStorage.setItem(KEY, JSON.stringify({ first: { landing: location.pathname.slice(0, 200), ts: Date.now() } }))
      return
    }
    touch.landing = location.pathname.slice(0, 200)
    touch.ts = Date.now()
    const cur = read()
    const firstValid = cur.first && cur.first.ts && Date.now() - cur.first.ts < FIRST_TTL && (cur.first.ref || Object.keys(cur.first).some((k) => PARAMS.includes(k)))
    localStorage.setItem(KEY, JSON.stringify({ first: firstValid ? cur.first : touch, last: touch }))
  } catch (e) { /* depolama kapalı olabilir */ }
}

/** Kayıt isteğine eklenecek gövde; veri yoksa undefined (alan hiç gönderilmez). */
export function acquisitionPayload(app) {
  try {
    if (!hasBrowser()) return undefined
    const cur = read()
    if (!cur.first && !cur.last) return undefined
    return { first: cur.first || null, last: cur.last || null, app }
  } catch (e) { return undefined }
}
